import { useEffect, useState } from "react";
import withLoader from "../../layouts/WithLoader"
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import SalesService from "../../../services/SellingService";
import BCService from "../../../services/BC";
import  makeAnimated  from 'react-select/animated';
import Select from "react-select";



const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};

const PayementTotalBillWallet = ({ startLoading, stopLoading }) => {
    const [openInfoAlert, setOpenInfoAlert] = useState(false);
    const [infoAlertText, setInfoAlertText] = useState();
    // const [wallet, setWallet] = useState();
    const [wallets, setWallets] = useState([]);
    const [walletId, setWalletId] = useState();
    const [selectedOption, setSelectedOption] = useState(null);
  
    const [amount, setAmount] = useState();
    const animatedComponents = makeAnimated();
  
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [walletSelectPlaceHolder, setWalletSelectPlaceHolder] =
      useState("Choisir...");
  
  
    const [walletSoldeSelectPlaceHolder, setWalletSoldeSelectPlaceHolder] =
      useState(null);
    useEffect(() => {
        const url = window.location.pathname.split("/")[1];
        if (url === "payerBill") {
            startLoading()
            TierAccountService.getWalletByTierFournisseur(getCurrentUserId(), localStorage.getItem("idTierWallet")).then((response) => {
                response.data.success.map((element) => {
                    if (element?.id !== undefined) {
                      setWallets((oldArray) => [
                        ...oldArray,
                        {
                          value: element.id, label: element.title, customElements: {
                            solde: element.solde
                          }
                        },
                      ]);
                    }
                    //here
                  });
                            }).catch((error) => {
                console.log("error", error)
            }).finally(() => {
                stopLoading();
            })
        }else{
            startLoading()
            TierAccountService.getWalletByTier(getCurrentUserId(), localStorage.getItem("idTierWallet")).then((response) => {
                response.data.success.map((element) => {
                    if (element?.id !== undefined) {
                      setWallets((oldArray) => [
                        ...oldArray,
                        {
                          value: element.id, label: element.title, customElements: {
                            solde: element.solde
                          }
                        },
                      ]);
                    }
                    //here
                  });            }).catch((error) => {
                console.log("error", error)
            }).finally(() => {
                stopLoading();
            })
        }
       

    }, [])




    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };

    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setOpenErrorAlert(false);
      };

    const payerBill = (e) => {
        const url = window.location.pathname.split("/")[1];
        if (url === "payerBill") {
            if(localStorage.getItem("restToPay") > walletSoldeSelectPlaceHolder){
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Vous ne pouvez pas payer par wallet ");
            }else{
                let payFactureOrAvance = {
                    idUser: getCurrentUserId(),
                    isFactureOrBDC: 1,
                    idDocument: parseInt(localStorage.getItem("idBill")),
                    isAvanceOrTotalPayement: 1,
                    typePayement: 4,
                    ammountPayed: localStorage.getItem("restToPay"),
                    banqueAccountId: walletId,
                    urlFile: "any",
    
                };
                startLoading();
                BCService.payFactureOrBDC(payFactureOrAvance)
                    .then((response) => {
                        if (response.data["error"]) {
                            setOpenErrorAlert(true);
                            setErrorAlertText("Erreur :"+response.data["error"]);
                        } else {
                            setTimeout(() => {
                                window.location.reload(true);
                            }, 2000);
    
                        }
                    })
                    .catch((error) => {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur : "+error);
                    }).finally(() => {
                        stopLoading();
                    });

            }
        
        } else {
            if(localStorage.getItem("restToPay") > walletSoldeSelectPlaceHolder){
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : Vous ne pouvez pas payer par wallet ");
            }else{
            let payementModel = {
                idUser: getCurrentUserId(),
                idDocument: parseInt(localStorage.getItem("idBill")),
                isAvanceOrTotalPayement: 1,
                isFactureOrBDC: 1,
                typePayement: 4,
                ammountPayed: localStorage.getItem("restToPay"),
                banqueAccountId: walletId,
                urlFile: "any",

            };
            startLoading();
            SalesService.payFactureOrBDC(payementModel)

                .then((response) => {
                    console.log(response);
                    if (response.data["error"]) {
                        setOpenErrorAlert(true);
                        setErrorAlertText("Erreur : "+response.data["error"]);
                    } else {
                        setTimeout(() => {
                            window.location.reload(true);
                        }, 2000);
                    }
                })
                .catch((error) => {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur : "+error);
                })
                .finally(() => {
                    stopLoading();
                });

        }
    }
    };
    const onChangeSelectedId = (selectedOptionn) => {
        setSelectedOption();
        setWalletId(selectedOptionn.value);
        setWalletSelectPlaceHolder(selectedOptionn.label);
        setWalletSoldeSelectPlaceHolder(selectedOptionn.customElements.solde)
    
      };
    return (<>
        <div className="row">
            <div className="col-12">
                <label>Payement par Wallet: </label>
            </div>
        </div>
        <div className="row">

        <Select
          styles={styles}
          closeMenuOnSelect={true}
          components={animatedComponents}
          defaultValue={selectedOption}
          onChange={onChangeSelectedId}
          options={wallets}
          placeholder={walletSelectPlaceHolder}
        />
        {/* <div className="col-12">
          <label>Wallet: {wallet?.title} </label>
        </div> */}
        <br />
        <div className="col-12">
         
          {walletSoldeSelectPlaceHolder!=null && <div className="col-12">
            <label>Solde: {walletSoldeSelectPlaceHolder} DNT</label>
          </div>}
        </div>

      </div>

        <div class="row">
            <div class="col-md-4">
                <label>Montant : </label>
                <input
                    disabled
                    type="number"
                    min="0"
                    step="0.1"
                    class="form-control"
                    name="amount"
                    value={localStorage.getItem("restToPay")}
                />
            </div>

            <br />
            <div class="col-12">
                <button
                    type="submit"
                    onClick={payerBill}
                    className="btn btn-dark float-right"
                >
                    Payer
                </button>
            </div>
        </div>
        <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
        <Snackbar
            open={openInfoAlert}
            autoHideDuration={4000}
            onClose={handleInfoClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
            <Alert onClose={handleInfoClose} severity="info">
                {infoAlertText}
            </Alert>
        </Snackbar>
    </>)


}
export default withLoader(PayementTotalBillWallet)